<template>
  <div class="page-content non-arrival-ticket">
    <h1 class="page-title">{{ $locale("sideMenu.operations.nonArrivalTicketRecord") }}</h1>

    <!-- Search Area -->
    <el-row class="search-area">
      <el-col class="makeInline" :lg="16" :md="24" :sm="24">
        <!-- <el-row :gutter="10">
          <el-col :span="24"> -->
            <DatePickerGroup
              v-bind:start="filter.startDate"
              v-bind:end="filter.endDate"
              v-bind:max="Infinity"
              @setFatherDate="getTime"
            ></DatePickerGroup>
            <el-button class="egl-btn-yellow" @click="search_fn">{{ $locale("global.search") }}</el-button>
          <!-- </el-col>
        </el-row> -->
      </el-col>
      <el-col class="ta-r" :lg="8" :md="24" :sm="24">
        <el-button class="egl-btn-yellow" @click="exportCSV_fn">{{ $locale("global.exportToCSV") }}</el-button>
      </el-col>
    </el-row>
    <el-row :gutter="10" class="search-area">
      <el-col :span="24" class="ta-r">
        <el-button class="egl-btn-yellow" @click="openDialog">{{ $locale("global.create") }}</el-button>
      </el-col>
    </el-row>

    <el-table :data="tableData" class="egl-table list-table" stripe @sort-change="sort_fn" ref="table" @filter-change="filterChange_fn">
      <el-table-column :label="$locale('global.id')" prop="searchId"></el-table-column>
      <el-table-column :label="$locale('operation.NAT.createTime')" prop="createTime" sortable="custom"></el-table-column>
      <el-table-column :label="$locale('trans.log.transactionFinishTime')" prop="finishedTime" ></el-table-column>
      <el-table-column :label="$locale('global.titleOfWork')" prop="filmName"></el-table-column>
      <el-table-column :label="$locale('operation.NAT.scheduleStartTime')" prop="startDay"></el-table-column>
      <el-table-column :label="$locale('operation.NAT.startTime')" prop="startTime"></el-table-column>
      <el-table-column
        :label="$locale('operation.NAT.ticketType')"
        prop="ticketName"
      ></el-table-column>
      <el-table-column :label="$locale('operation.NAT.qty')" prop="qty"></el-table-column>
      <el-table-column :label="$locale('operation.NAT.amountOfBoxOfficeRevenue')" prop="payAmount"></el-table-column>
      <!-- <el-table-column
        :label="$locale('operation.NAT.device')"
        prop="deviceName"
        :filters="deviceArr"
        :filtered-value="deviceValues"
        column-key="device"
      ></el-table-column> -->
      <el-table-column :label="$locale('operation.NAT.changePeople')" prop="dutyPerson"></el-table-column>
      <el-table-column :label="$locale('operation.NAT.comment')" prop="comment"></el-table-column>
      <el-table-column :label="$locale('global.control')">
        <template slot-scope="scope">
          <div class="handle">
            <a @click="delete_fn(scope.row)">{{ $locale("global.delete") }}</a>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <CommPagination
      :total="pageCount"
      :curPage="onSearch.page"
      :pageSize="onSearch.pageSize"
      @current-change="choosePage"
    />

    <el-dialog
      :title="dialogTitle"
      :visible="isShow"
      class="egl-dialog-elm egl-dialog"
      :before-close="closeDialog"
      :show-close="true"
      width="1000px"
      :close-on-click-modal="false"
    >
      <el-form label-position="top">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$locale('global.works') + ' *'">
              <el-select v-model="form.filmId" @change="selectFilm" :filterable="true">
                <el-option v-for="item in filmList" :key="item.id" :value="item.id" :label="item.name"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="16">
              <el-row>
                <el-form-item :label="$locale('trans.report.ticketing.time') + ' *'">
                  <el-row :gutter="10">
                    <el-col :span="12">
                      <CommDatePicker
                        v-model="form.date"
                        :value.sync="form.date"
                        width="100%"
                        :showWeekly="true"
                      />
                    </el-col>
                    <el-col :span="4"><el-input
                      :placeholder="$locale('trans.report.ticketing.plsInputTime')"
                      v-model="form.hour"
                      @input="(value) => timeInput_fn(value, 'hour')"
                      @change="setSaveBtn"
                    /></el-col>
                    <el-col :span="1" style="text-align: center">:</el-col>
                    <el-col :span="4"><el-input
                      :placeholder="$locale('trans.report.ticketing.plsInputTime')"
                      v-model="form.minute"
                      @input="(value) => timeInput_fn(value, 'minute')"
                      @change="setSaveBtn"
                    /></el-col>
                  </el-row>
                </el-form-item>
              </el-row>
            </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$locale('operation.NAT.screenDate') + ' *'">
              <CommDatePicker
                v-model="scheduleTime"
                :value.sync="scheduleTime"
                width="100%"
                :showWeekly="true"
                @change="resetFilm"
                @reset="resetFilm"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$locale('operation.NAT.showTime') + ' *'">
              <el-select v-model="form.scheduleId" @change="setSaveBtn">
                <el-option v-for="item in scheduleOption" :key="item.scheduleId" :value="item.scheduleId" :label="item.time"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$locale('operation.NAT.advanceTicket') + ' *'">
              <el-select v-model="form.advanceTicketId" @change="setSaveBtn">
                <el-option
                  v-for="item in advanceTicketOption"
                  :key="item.uuid"
                  :value="item.uuid"
                  :label="`${item.name} (${item.ticketingCode}${item.ticketingCode ? '/' : ''}${item.boxOfficeAmount}/${item.displayAmount})`"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$locale('operation.NAT.qty') + ' *'">
              <el-input v-model="form.qty" :placeholder="$locale('operation.NAT.placeholder.input')" @input="inputNum"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item :label="$locale('operation.NAT.comment')">
              <el-input v-model="form.comment" :placeholder="$locale('operation.NAT.placeholder.input')" @input="setSaveBtn"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-button class="egl-btn-white" @click="closeDialog">{{ $locale("global.cancel") }}</el-button>
            <el-button class="egl-btn-yellow" @click="save_fn" :disabled="saveBtnDisabled">{{ $locale("global.save") }}</el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import DatePickerGroup from "@/components/DatePickerGroup";
import {
  getNonArrivalTicketList,
  getFilmList,
  getScheduleList,
  createNonArrivalTicket,
  deleteNonArrivalTicket,
  exportCSV,
  getAdvanceCouponTypeList,
} from "@/helpers/service/api/operations";
import { getDeviceList } from "@/helpers/service/api/device";
import { getMoviTicketListService, getMovieDetail } from "@/helpers/service/api/movie";
import { requestAll } from "@/helpers/service/axiosPlugin";
import CommDatePicker from "@/components/common/CommDatePicker";
import CommPagination from "@/components/common/CommPagination";
import { getYears, getMonths, getDays } from "@/assets/js/NonArrivalTicket";
import { generateTimeStamp, hourMinuteLimit_fn } from "@/utils/transaction";
import countDownAlert from "@/utils/countDownAlert";
import { getExportName_fn } from '@/utils/common'
import { weekLocaleArray } from "@/utils/common";

export default {
  name: "NonArrivalTicket",
  data() {
    return {
      onSearch: {
        startDate: 0,
        endDate: 0,
        page: 0,
        pageSize: 10,
        sort: "",
      },
      filter: {
        startDate: 0,
        endDate: 0,
        page: 0,
        pageSize: 10,
        sort: "",
      },
      tableData: [],
      cinemaId: "",
      pageCount: 0,

      dialogTitle: this.$locale("operation.NAT.dialogTitle"),
      isShow: false,
      saveBtnDisabled: true,
      form: {},
      filmList: [],
      advanceTicketOption: [],
      scheduleTime: 0,
      scheduleOption: [],
      scheduleOriginData: [],
      advanceCouponTypeList: [],
      ticketTypeFilters: [
        {
          text: this.$locale("cashierReport.dialog.nationalTicket"),
          value: "NATIONWIDE"
        },
        {
          text: this.$locale("couponLib.theaterAdvTicket"),
          value: "PRE_SALES"
        },
        {
          text: this.$locale("couponLib.invitationTicket"),
          value: "INVITATION"
        }
      ],
      deviceArr: [],
      deviceValues: [],
      hourMinuteLimit_fn
      // pickerOptions: {
      //   disabledDate: this.disabledDate,
      // },
    };
  },
  methods: {
    search_fn() {
      this.onSearch = { ...this.filter };
      this.getData();
    },
    getTime(obj) {
      this.filter = { ...this.filter, ...obj };
    },
    getData(filters) {
      if (this.cinemaId == "") {
        this.$emit("callCinema", "getData");

        return;
      }

      let obj = {
        ...this.onSearch,
        cinemaId: this.cinemaId,
        ...filters && filters.ticketType ? { ticketType: filters.ticketType } : {},
        ...filters && filters.device ? { deviceSecret: filters.device } : {}
      };

      obj.startDate = this.$moment(obj.startDate).format("YYYY-MM-DD");
      obj.endDate = this.$moment(obj.endDate).format("YYYY-MM-DD");

      getNonArrivalTicketList(obj).then(res => {
        if (res.success) {
          let tableData = [];
          // let pageCount = 1;
          const week = [
            this.$locale("global.sun"),
            this.$locale("global.mon"),
            this.$locale("global.tue"),
            this.$locale("global.wed"),
            this.$locale("global.thu"),
            this.$locale("global.fri"),
            this.$locale("global.sat")
          ];
          const ticketTypeObj = {
            NATIONWIDE: this.$locale("cashierReport.dialog.nationalTicket"),
            PRE_SALES: this.$locale("couponLib.theaterAdvTicket"),
            INVITATION: this.$locale("couponLib.invitationTicket")
          };
          if (res.data) {
            // pageCount = Math.ceil(res.data.count / obj.pageSize);
            res.data.data.map(item => {
              let { device, searchId, createTime, film, startTime, qty, payAmount, dutyPerson, comment, ticketType, finishedTime, transactionId, ticketName } = item;
              let tr = {
                searchId: searchId && item.searchId,
                createTime: createTime && this.$moment(item.createTime).format("YYYY/MM/DD HH:mm"),
                filmName: film && item.film.name,
                startDay: startTime && this.$moment(item.startTime).format("YYYY/MM/DD"),
                startTime: startTime && this.$moment(item.startTime).format("HH:mm"),
                ticketType: ticketType && ticketTypeObj[item.ticketType],
                qty: qty && item.qty,
                payAmount: payAmount && "¥" + item.payAmount.toLocaleString(),
                deviceName: device && item.device.name,
                dutyPerson: dutyPerson && item.dutyPerson,
                comment: comment && item.comment,
                itemId: item.itemId,
                finishedTime: finishedTime && this.$moment(item.finishedTime).format("YYYY/MM/DD HH:mm"),
                transactionId,
                ticketName
              };
              tr.createTime = tr.createTime.replace(" ", `(${week[this.$moment(item.createTime).day()]}) `);
              tr.finishedTime = tr.finishedTime.replace(" ", `(${week[this.$moment(item.finishedTime).day()]}) `);
              tr.startDay += `(${week[this.$moment(item.startTime).day()]})`;
              tableData.push(tr);
            });
          }
          this.tableData = tableData;
          // this.pageCount = resres.data.count || 0;
          this.pageCount = res.data ? res.data.count : 0;
        }
      });
    },
    choosePage(page) {
      this.onSearch.page = page - 1;

      this.getData();
    },
    sort_fn({ prop, order }) {
      let sort = "";

      if (order) {
        if (order == "ascending") {
          sort = `${prop}:ASC`;
        } else {
          sort = `${prop}:DESC`;
        }
      }

      this.filter.sort = sort;
      this.onSearch.sort = sort;
      this.getData();
    },
    exportCSV_fn() {
      let fileName = 
      // this.$locale("sideMenu.operations.nonArrivalTicketRecord") + ".csv";
      getExportName_fn(
        this.$locale("sideMenu.operations.nonArrivalTicketRecord"),
        '',
        '',
        '',
        `${this.$moment(this.filter.startDate).format('YYYY-MM-DD')} （${weekLocaleArray[this.$moment(this.filter.startDate).day()]}）~ ${this.$moment(this.filter.endDate).format('YYYY-MM-DD')} （${weekLocaleArray[this.$moment(this.filter.endDate).day()]}）`,
        '',
        this.$moment().format('YYYYMMDDHHmm')
      ) + '.csv'
      let queryString = "cinemaId=" + this.cinemaId + "&startDate=" + this.$moment(this.onSearch.startDate).format("YYYY-MM-DD") + "&endDate=" + this.$moment(this.onSearch.endDate).format("YYYY-MM-DD");

      exportCSV(queryString).then(res => {
        const bom = new Uint8Array([0xEF, 0xBB, 0xBF]); // UTF-8 BOM
        const content = new TextEncoder().encode(res);
        const blob = new Blob([ bom, content ], { type: 'text/csv;charset=utf-8;' });
        const blobUrl = window.URL.createObjectURL(blob);
        const aElement = document.createElement("a");
        aElement.href = blobUrl;
        aElement.download = fileName;
        aElement.click();
        window.URL.revokeObjectURL(blobUrl);
      });
    },
    delete_fn(obj) {
      const that = this;
      let confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${this.$locale("global.delete")} ${obj.searchId}</span>`;

      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.delete"),
        customClass: "egl-confirm",
        closeOnClickModal: false
      }).then(() => {
        // confirm
        deleteNonArrivalTicket({
          itemId: obj.itemId,
          transactionId: obj.transactionId,
          userId: window.localStorage.getItem("accountId")
        }).then(res => {
          if (res.success) {
            that.getData();
          }
        });
      });
    },

    openDialog() {
      requestAll([
        getFilmList({
          cinemaId: window.localStorage.getItem("cinemaId"),
          page: 0,
          pageSize: 9999,
          field: ["id", "name"],
          status: "active",
          approve: true,
          hiddenCms: false,
        }),
        getAdvanceCouponTypeList(this.cinemaId),
      ]).then(res => {
        this.filmList = res[0].data ? res[0].data.data || [] : [];
        const _advanceCouponTypeList = res[1].data ? res[1].data.data || [] : [];

        this.advanceCouponTypeList = _advanceCouponTypeList.map(item => ({
          uuid: item.id || "",
          name: item.name || "",
          boxOfficeAmount: item.boxOfficeAmount || 0,
          displayAmount: item.actualAmount || 0,
          ticketingCode: item.ticketingCode || "",
        }));
        this.form = this.createForm();
        this.scheduleTime = this.$moment().valueOf();
        this.saveBtnDisabled = true;
        this.isShow = true;
      });
    },
    closeDialog() {
      this.filmList = [];
      this.scheduleOption = [];
      this.advanceTicketOption = [];
      this.isShow = false;
    },
    createForm() {
      return {
        filmId: "",
        advanceTicketId: "",
        qty: "",
        comment: "",
        scheduleId: "",
        date: this.$moment().startOf("day").valueOf(),
        hour: "",
        minute: "",
      };
    },
    save_fn() {
      createNonArrivalTicket({
        ...this.form,
        transactionFinishTime: this.transactionFinishTime
      }).then(res => {
        if (res.success) {
          countDownAlert({ content: this.$locale("global.createSuccessfully"), callback: () => {
            this.closeDialog();
            this.getData();
          } });
        }
      });
    },
    selectFilm() {
      const { filmId } = this.form;
      // let arr = [];

      // for (let i = 0; i < this.filmList.length; i++) {
      //   if (this.filmList[i].id == filmId) {
      //     arr = [...this.filmList[i].nationalTicket, ...this.filmList[i].otherNationalTicket];
      //     break;
      //   }
      // }

      // this.advanceTicketOption = [...arr, ...this.advanceCouponTypeList];
      this.scheduleOption = [];
      this.form.advanceTicketId = "";
      this.form.scheduleId = "";
      this.getScheduleList_fn();
      this.setSaveBtn();
      getMoviTicketListService({
        filmId,
        type: "film",
        page: 0,
        pageSize: 9999
      }).then(res => {
        const resData = res.data ? res.data.data || [] : [];
        const _arr = resData.map(item => ({
          uuid: item.id || "",
          name: item.name || "",
          boxOfficeAmount: item.boxOfficeAmount || 0,
          displayAmount: item.sellAmount || 0,
          ticketingCode: item.ticketingCode || "",
        }));

        this.advanceTicketOption = [...this.advanceCouponTypeList, ..._arr];

        getMovieDetail(filmId).then(res => {
          if(res.data && res.data.otherNationalTicket.length > 0) {
            res.data.otherNationalTicket.forEach(item => {
              this.advanceTicketOption.push({
                uuid: item.uuid || "",
                name: item.name || "",
                boxOfficeAmount: item.boxOfficeAmount || 0,
                displayAmount: item.actualAmount || 0,
                ticketingCode: item.ticketingCode || "",
              });
            });
          }
        });
      });
    },
    setSaveBtn() {
      let saveBtnDisabled = false;

      for (let keyName in this.form) {
        // changed: form.comment is not a madatory field
        if (!this.form[keyName] && keyName != "comment") {
          saveBtnDisabled = true;
        }
      }

      this.saveBtnDisabled = saveBtnDisabled;
    },
    inputNum() {
      let num = this.form.qty;

      num = parseFloat(num.toString().replace(/[^\d-]/g, "")) || 0;

      this.form.qty = num;
      this.setSaveBtn();
    },
    dayHandle(date) {
      this.scheduleTime = date;
      this.form.scheduleId = "";
      this.getScheduleList_fn();
    },
    formatTime(time, type) {
      const timeString = this.$moment(time).format("YYYY-MM-DD");
      return type === "start" ? this.$moment(timeString).startOf("day").valueOf() : this.$moment(timeString).endOf("day").valueOf();
    },
    generateTimeArr(data) {
      return data.map(item => item.showStartTime);
    },
    getScheduleList_fn() {
      let { filmId } = this.form;
      // let date = this.$moment(this.scheduleTime).startOf("day").valueOf();

      if (filmId) {
        getScheduleList(filmId, this.cinemaId).then(res => {
          if (res.success) {
            this.scheduleOriginData = res.data;
            const startTimeLimit = this.formatTime(this.scheduleTime, "start");
            const endTimeLimit = this.formatTime(this.scheduleTime);
            let scheduleOption = [];

            res.data.map(item => {
              if (item.scheduleStatus == "release" && (item.showStartTime >= startTimeLimit && item.showStartTime <= endTimeLimit)) {
                scheduleOption.push({
                  scheduleId: item.scheduleId,
                  time: this.$moment(item.showStartTime).format("HH:mm") + " [" + item.houseName + "]",
                  schedule: item.showStartTime,
                  filmName: item.filmName
                });
              }
            });
            this.scheduleOption = scheduleOption;
          }
        });
      }
    },
    filterChange_fn(filters) {
      this.getData(filters);
    },
    // disabledDate(time) {
    //   const currentYear = time.getFullYear();
    //   const targetObj = this.availableObj[currentYear];
    //   const currentMonth = time.getMonth() + 1;
    //   const currentDay = time.getDate();
    //   const isExist = Object.keys(this.availableObj).length > 0;
    //   if(!isExist) { return false; }
    //   if(isExist && !targetObj) { return true; }
    //   if(isExist && !targetObj[currentMonth]) { return true; }
    //   if(isExist && !targetObj[currentMonth].includes(currentDay)) { return true; }
    // },
    resetFilm() {
      let scheduleOption = [];
      this.form.scheduleId = "";
      const startTimeLimit = this.formatTime(this.scheduleTime, "start");
      const endTimeLimit = this.formatTime(this.scheduleTime);
      this.scheduleOriginData.map(item => {
        if (item.scheduleStatus == "release" && (item.showStartTime >= startTimeLimit && item.showStartTime <= endTimeLimit)) {
          scheduleOption.push({
            scheduleId: item.scheduleId,
            time: this.$moment(item.showStartTime).format("HH:mm") + " [" + item.houseName + "]",
            schedule: item.showStartTime,
            filmName: item.filmName
          });
        }
      });
      this.scheduleOption = scheduleOption;
    },
    timeInput_fn(value, type) {
      this.setSaveBtn();
      hourMinuteLimit_fn(this.form, value, type);
    }
  },
  created() {
    getDeviceList({
      cinemaId: window.localStorage.getItem("cinemaId"),
      page: 0,
      pageSize: 9999
    }).then(res => {
      res.data.data.forEach(item => {
        this.deviceArr.push({
          text: item.name,
          value: item.deviceSecret
        });
        this.deviceValues.push(item.deviceSecret);
      });
    });
  },
  mounted() {
    const cinemaId = window.localStorage.getItem("cinemaId") || "";
    let today = this.$moment().valueOf();

    this.cinemaId = cinemaId;
    this.filter.startDate = today;
    this.filter.endDate = today;
    this.onSearch.startDate = today;
    this.onSearch.endDate = today;
    this.getData();
  },
  components: {
    DatePickerGroup,
    CommDatePicker,
    CommPagination,
  },
  computed: {
    availableObj() {
      // 获取可用的年
      const years = getYears(this.scheduleOriginData);//Array<string>
      const scheduleData = this.scheduleOriginData;
      let _obj = {};
      years.forEach(year => {
        getMonths(scheduleData, year).forEach(month => {
          _obj[year] = {
            [month + 1]: getDays(scheduleData, month)
          };
        });
      });
      return _obj;
    },
    transactionFinishTime() {
      return generateTimeStamp(this.form);
    },
  }
};
</script>
